import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[alert-data-ctrl]',
    standalone: false
})
export class AlertDataCtrlDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}